export class BuyerOwnerValidationResultDto {
    confirmationMessages: string[];
}
